import React from "react";
import sdk from "src/sdk";

import { BoxWithKeyboardPadding } from "src/banking/components";
import { DynamicForm } from "src/components/Form";
import { mergeWithFieldValidation } from "src/components/Form/validation";

import {
  verificationFields,
  ssnField,
} from "src/banking/authentication/sharedFields";
import { verficationFieldsValidator } from "src/banking/authentication/validation";

const entryFormFieldProps = {
  labelTop: true,
  renderErrorBelow: true,
};

const fields = ({ t }) => [
  {
    type: "section",
    title: "Forgot Security Questions",
    fields: [
      {
        key: "acn",
        label: "Member Number",
        helpText: "This is your member number at Financial Center",
        required: true,
        inputProps: {
          ...entryFormFieldProps,
        },
      },
      ssnField({ t, inputProps: entryFormFieldProps }),
    ],
  },
  ...verificationFields({ t, inputProps: entryFormFieldProps }),
];

const ForgotChallengeQuestionsEntryForm = props => (
  <BoxWithKeyboardPadding>
    <DynamicForm
      formKey="forgotLogin"
      fields={fields}
      customValidator={mergeWithFieldValidation(verficationFieldsValidator)}
      {...props}
    />
  </BoxWithKeyboardPadding>
);

export default ForgotChallengeQuestionsEntryForm;



// WEBPACK FOOTER //
// ./src/banking/authentication/ForgotFlow/ForgotChallengeQuestions/steps/Entry.js